import { inject, Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { AffiliateAssignmentApiDto } from '../../shared/models/affiliate';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AffiliateService {
  private readonly httpService = inject(HttpService);

  getAssignmentForBriefAndCreator(params: {
    briefId: string;
    creatorId: string;
    provider?: string;
    providerAccountId?: string | null;
  }): Observable<AffiliateAssignmentApiDto | null> {
    const { briefId, creatorId, provider = 'shopify', providerAccountId } = params;

    const searchParams = new URLSearchParams();
    if (provider) {
      searchParams.set('provider', provider);
    }
    if (providerAccountId) {
      searchParams.set('providerAccountId', providerAccountId);
    }

    const qs = searchParams.toString();
    const path = `/affiliate/assignment/${briefId}/${creatorId}${qs ? `?${qs}` : ''}`;

    return this.httpService.runHttpCall('GET', path, 'application/json');
  }
}
